import Component from '@glimmer/component'
import { service } from '@ember/service'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'
import { featureFlag } from 'teacher-ui-client/helpers/feature-flag'
import { or, notEq } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type { SkillsMasteredReData } from 'teacher-ui-client/utils/student-events/fetchers/skills-mastered'

interface Signature {
  Args: {
    data: SkillsMasteredReData
  }
}

export class DashboardSkillsMasteredRe extends Component<Signature> {
  @service lessonInfo!: LessonInfoService

  get weakestLessonName() {
    const weakestLessonNumber = this.args.data.weakest_lesson

    const reLessons = this.lessonInfo.lessonsFor(Precinct.RE_READING)
    const weakestLesson = reLessons.find((lesson) => lesson.lesson_position === weakestLessonNumber)
    return weakestLesson?.name
  }

  get colorClasses() {
    return ['text-oceany-blue-300', 'text-ms-green-300', 'text-rexy-purple-300', 'text-purply-pink-300']
  }

  get skillsMasteredByLevel() {
    const averageByLevel = this.args.data.average_by_level ?? []
    return averageByLevel.map((avg, index) => ({
      value: avg ?? 0,
      range: this.args.data.lesson_ranges[index],
      colorClass: this.colorClasses[index],
    }))
  }
  <template>
    <div class="mx-8 grid h-full grid-cols-2 gap-8 pt-8" data-test-skills-mastered>
      {{#each this.skillsMasteredByLevel as |levelData index|}}
        {{#if (or (notEq index 3) (featureFlag "tui_re_dash_skills_mastered_level_four"))}}
          <div data-test-skills-mastered-level={{levelData.range}}>
            <div class="text-3xl font-bold {{levelData.colorClass}}" data-test-skills-mastered-value>
              {{levelData.value}}
            </div>
            <div class="whitespace-nowrap sm:text-base md:text-xs lg:text-base" data-test-skills-mastered-range>
              {{t "lessons"}}
              {{levelData.range}}
            </div>
            <hr class="border-dusty-black-100 my-2 border-b px-8" />
          </div>
        {{/if}}
      {{/each}}
      <div class="col-span-2 text-center" data-test-skills-mastered-weakest-lesson>
        <div class="font-bold whitespace-nowrap">
          {{t "components.reporting.charts.dashboard.skillsMastered.re.mostCommonWeakness"}}:
        </div>
        {{#if this.weakestLessonName}}
          <div>{{t "lesson"}} {{@data.weakest_lesson}}: {{this.weakestLessonName}}</div>
        {{else}}
          -
        {{/if}}
      </div>
    </div>
  </template>
}

export default DashboardSkillsMasteredRe
